module.exports = __webpack_public_path__ + "img/emoji-smile.400ad9ba.png";